<template>
    <div :class="stClass">
        <section class="page-hd">
            <div class="sponsor">
                <div class="sponsor-img"></div>
            </div>
            <div class="act">
                <div class="act-img"></div>
                <div class="act-desc">
                    <img v-if="img" class="full_img guide_img" :src="img" />
              </div>
              
            </div>
        </section>
        <section class="page-ft">
            <a class='download' href="https://www.wechat.com/mobile/en/​" target="_self">https://www.wechat.com/mobile/en/​</a>
        </section>
    </div>
</template>
<script>
import { getLangConfig } from '../business';

export default {
    name: 'guide',
    props: [],
    components: {},
    data: function() {
        return {
            lang: "en",
            img: "",
            guideTitle: ""
        }
    },
    created() {
        getLangConfig().then(({ lang, langObj }) => {
            console.log("not_inweixin_guide_img", langObj.not_inweixin_guide_img);
            this.lang = lang;
            this.img = langObj.not_inweixin_guide_img;
            this.guideTitle = langObj.guideTitle || "指引下啊沙发舒服"
        });
    },
    computed: {
        stClass: function() {
            return `st-box lang-${this.lang}`;
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    @rem: 200rem;
    .full_img{
        width: 713/@rem;
    }
    .guide_img{
        margin-top: 50/@rem;
    }
    .act{
        text-align:center;
    }
    .download{
        font-size: 36/@rem;
        color: #fff;
        text-align: center;
        text-decoration: underline;
    }
    .lang_en{
        .guide_img{
            margin-left: 50/@rem;
        }
    }
    .page-ft{
        height: 100/@rem;
        padding: 0;
        margin: 0;
        background: #03a344;
    }
    .st-box{
        padding-bottom: 0;
    }
    .act-desc{
        margin-bottom: 0;
    }
    
</style>
